import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import createScript from '../../../../../utils/create-script'
import { init_safecharge_google_pay, open_safecharge_google_pay, set_safecharge_google_result, billingCheckout, billingPlaceOrder } from '../../../../../../api'
import { useSelector } from 'react-redux'
import Paying from '../../../pages/credit-pay/components/loading/paying'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useLanguage } from '../../../../../hooks/common'

const baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
}

const allowedCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"]
const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"]

export default props => {
    useStyles(classes)
    const { onError, country, orderTotal, payMethod, inputOrder, shoudBilling, clickHandle, isFastPayment, check } = props
    const [account, setAccount] = useState({})
    const instance = useRef()
    const [paymentsClient, setPaymentsClient] = useState(null)
    const [loading, setLoading] = useState(false)
    const container = useRef()
    const global = useSelector(state => state.global)
    const isSandbox = global?.config?.env === 'sandbox'
    const language = useLanguage()

    const tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            'gateway': 'nuveidigital',
            'gatewayMerchantId': isSandbox ? 'googletest': 'nuveidigital' //'googletest' for test or 'nuveidigital' for production
        }
    }

    const baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks
        }
    }

    const cardPaymentMethod = Object.assign(
        { tokenizationSpecification: tokenizationSpecification },
        baseCardPaymentMethod
    )

    const payWithGooglePay = async paymentData => {

        setLoading(true)
        let orderResponse
        if (inputOrder) {
            orderResponse = {
                result: inputOrder,
                code: 200
            }
        } else {
            if (shoudBilling) {
                await billingCheckout()
            }
            orderResponse = await billingPlaceOrder(isFastPayment)
        }

        if (orderResponse?.code === 200 && orderResponse?.result) {

            const order = orderResponse?.result
            const openResponse = await open_safecharge_google_pay({
                orderId: order?.id,
                merchantSiteId: account?.merchantSiteId,
                payMethod
            })

            if (openResponse?.code === 200 && openResponse?.result) {
                const {
                    openOrderResponse,
                    email,
                    country,
                    ip
                } = openResponse?.result

                instance.current.createPayment({
                    sessionToken: openOrderResponse?.sessionToken,
                    merchantId: openOrderResponse?.merchantId,
                    merchantSiteId: openOrderResponse?.merchantSiteId,
                    clientUniqueId: openOrderResponse?.clientUniqueId, // optional
                    "paymentOption": {
                        "card": {
                            "externalToken": {
                                "externalTokenProvider": "GooglePay",
                                "mobileToken": JSON.stringify(paymentData.paymentMethodData),
                            }
                        }
                    },
                    billingAddress: {
                        email: email,
                        country: country
                    },
                    'deviceDetails': {
                        'ipAddress': ip
                    }
                }, async crRes => {
                    console.log(crRes)

                    await set_safecharge_google_result({
                        ...crRes,
                        transactionId: order?.transactionId,
                        payMethod,
                        sessionToken: openOrderResponse?.sessionToken,
                    }).catch(e => {
                        console.error(e)
                    })

                    if(crRes?.result === 'APPROVED'){
                        window.location.href = `/order-confirm/${order.transactionId}`
                    }else{
                        onError({
                            message: crRes?.errorDescription || crRes?.reason || 'Network Error'
                        })
                    }
                    setLoading(false)
                })
            }
        }else{
            setLoading(false)
            onError({
                message: orderResponse?.result || 'Network Error'
            })
        }
    }

    const googleClick = (client) => {


        try {
            clickHandle?.()
            if(check){
                if(!check()){
                    return false
                }
            }
        } catch (error) {
            
        }


        const paymentDataRequest = Object.assign({}, baseRequest)
        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod]

        paymentDataRequest.transactionInfo = {
            totalPriceStatus: 'FINAL',
            totalPrice: orderTotal.amount,
            currencyCode: orderTotal.currency,
            countryCode: country
        }

        paymentDataRequest.merchantInfo = {
            // merchantName: global?.config?.name,
            merchantName: "nuveidigital",
            merchantId: isSandbox? '12345678901234567890': global?.config?.safecharge?.googleMerchant
        }

        client.loadPaymentData(paymentDataRequest).then(function (paymentData) {
            payWithGooglePay(paymentData)
            // if using gateway tokenization, pass this token without modification
            // const paymentToken = paymentData.paymentMethodData.tokenizationData.token
            //createPayment
        }).catch(function (err) {
            console.error(err)
            if (err?.statusCode === 'CANCELED') {

            } else {
                onError({
                    message: JSON.stringify(err)
                })
            }
        })
    }


    useEffect(async () => {
        const [s, b, initResponse] = await Promise.all([
            createScript('safecharge-pay-script', 'https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js'),
            createScript('google-pay-script', 'https://pay.google.com/gp/p/js/pay.js'),
            init_safecharge_google_pay({ payMethod })
        ])

        if (initResponse.code === 200 && initResponse.result) {
            setAccount(initResponse.result)

            instance.current = window.SafeCharge({
                env: isSandbox ? 'int': 'prod', // Nuvei API environment - 'int' (integration) or 'prod' (production - default if omitted)
                merchantId: initResponse.result.merchantId, // your Merchant ID provided by Nuvei
                merchantSiteId: initResponse.result.merchantSiteId, // your Merchant site ID provided by Nuvei
            })

        } else {
            onError({
                message: initResponse.result || 'Network Error.'
            })
        }

        if (window.google) {
            const client = new window.google.payments.api.PaymentsClient({ environment: isSandbox ? 'TEST': 'PRODUCTION' }) //PRODUCTION
            setPaymentsClient(client)

            const isReadyToPayRequest = Object.assign({}, baseRequest)
            isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod]

            client.isReadyToPay(isReadyToPayRequest).then(response => {
                if (response.result) {
                    const button = client.createButton({
                        buttonSizeMode: 'fill',
                        buttonType: 'pay',
                        buttonLocale: language || 'en',
                        onClick: () => googleClick(client),
                    }) // make sure to provide an allowed payment method
                    container.current.appendChild(button)
                }
            }).catch(function (err) {
                // show error in developer console for debugging
                console.error(err)
            })
        }



    }, [])


    return <>
        <div ref={container} className={classes.Container}></div>
        {
            loading && ReactDOM.createPortal(<Paying/>, document.getElementById('root'))
        }
    </>

}